// src/pages/AboutDrSridhar.jsx
import React, { useEffect, useRef } from 'react';
// Import your main doctor photo here (you already have one)
import doctorPortrait from '../Assets/TeamandOthers/AboutDr1.webp';
import { FaFacebookF, FaLinkedinIn, FaInstagram } from 'react-icons/fa';
import Aboutdrimg from '../Assets/TeamandOthers/Interiorimg.webp'
import Aboutdrimg2 from '../Assets/Awards/Picture4.webp'
import Aboutdrimg3 from '../Assets/Awards/Picture3.webp'
import Aboutdrimg4 from '../Assets/Awards/Picture5.webp'
import Aboutdrimg5 from '../Assets/Awards/Picture1.webp'
import Aboutdrimg6 from '../Assets/Awards/Picture7.webp'

const RevealFromBottom = ({ children, delay = 0 }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.08 }
    );

    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className="reveal-from-bottom"
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

const AboutDrSridhar = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">

        {/* Hero Section */}
        <RevealFromBottom delay={100}>
          <div className="text-center mb-16 ">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Dr. Arumalla Sridhar Reddy
            </h1>
            <p className="text-xl text-blue-600 font-medium">
              BDS, MDS – Dental, Oral & Maxillofacial Surgeon
            </p>
            <p className="text-lg text-gray-600 mt-3 italic">
              In Service of Humanity – A Self-Made Pioneer in Dentistry & Social Welfare
            </p>
          </div>
        </RevealFromBottom>

        {/* Main Profile + Hospital Intro */}
        <RevealFromBottom delay={200}>
  <section className="mb-24 px-4">
    <div className="max-w-7xl mx-auto">
      <div className="bg-white rounded-3xl shadow-2xl border border-gray-100 overflow-hidden">
        
        <div className="flex flex-col lg:flex-row">
          
          {/* LEFT COLUMN */}
          <div className="lg:w-2/5 bg-gradient-to-b from-blue-50 to-white flex flex-col">
            
            {/* Image */}
            <div className="relative group">
              <div className="aspect-[4/5] lg:aspect-auto h-[420px]">
                <img
                  src={doctorPortrait}
                  alt="Dr. Arumalla Sridhar Reddy"
                  className="absolute inset-0 w-[85%] h-[85%] object-cover ml-[8%] mt-[6%] rounded-2xl shadow-xl transition-transform duration-700 group-hover:scale-105"
                />
              </div>
            </div>

            {/* Info Card */}
            <div className="p-8 border-t border-gray-200 bg-white">
              <h4 className="text-xl font-bold text-blue-700 mb-5 tracking-wide">
                Personal Information
              </h4>

        <ul className="space-y-4 text-sm text-gray-700">
  {/* Add 'flex-col' for mobile, 'sm:flex-row' for larger screens */}
  <li className="flex flex-col sm:flex-row sm:justify-between border-b border-gray-100 pb-2 sm:border-0">
    <span className="font-semibold text-gray-900">Qualification</span>
    <span className="text-gray-600 sm:text-right">B.D.S., M.D.S.</span>
  </li>
  
  <li className="flex flex-col sm:flex-row sm:justify-between border-b border-gray-100 pb-2 sm:border-0">
    <span className="font-semibold text-gray-900">Specialization</span>
    <span className="text-gray-600 sm:text-right">Oral & Maxillofacial Surgery</span>
  </li>

  <li className="flex flex-col sm:flex-row sm:justify-between border-b border-gray-100 pb-2 sm:border-0">
    <span className="font-semibold text-gray-900">Position</span>
    <span className="text-gray-600 sm:text-right">Chairman</span>
  </li>

  <li className="flex flex-col sm:flex-row sm:justify-between border-b border-gray-100 pb-2 sm:border-0">
    <span className="font-semibold text-gray-900">Contact</span>
    <span className="text-gray-600 sm:text-right underline decoration-gray-300">98481 28342</span>
  </li>

  <li className="flex flex-col sm:flex-row sm:justify-between break-all">
    <span className="font-semibold text-gray-900">Email</span>
    <span className="text-blue-600 sm:text-right">drasridhar@yahoo.com</span>
  </li>
</ul>

              {/* Social Icons */}
              <div className="mt-6 flex gap-5">
                <a href="#" className="bg-gray-100 p-3 rounded-full text-gray-600 hover:bg-blue-600 hover:text-white transition duration-300">
                  <FaFacebookF className="w-4 h-4" />
                </a>
                <a href="#" className="bg-gray-100 p-3 rounded-full text-gray-600 hover:bg-blue-700 hover:text-white transition duration-300">
                  <FaLinkedinIn className="w-4 h-4" />
                </a>
                <a href="#" className="bg-gray-100 p-3 rounded-full text-gray-600 hover:bg-pink-500 hover:text-white transition duration-300">
                  <FaInstagram className="w-4 h-4" />
                </a>
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div className="flex-1 p-8 md:p-12">
            
            {/* Heading */}
            <div className="mb-6">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800">
                Dr. Arumalla Sridhar Reddy
              </h2>
              <p className="text-blue-600 font-medium mt-2">
                Dental, Oral & Maxillofacial Surgeon
              </p>
              <div className="w-20 h-1 bg-blue-600 mt-4 rounded"></div>
            </div>

            {/* Bio Content */}
            <div className="text-gray-700 leading-relaxed space-y-6 text-lg">
              <p>
                Dr. Arumalla Sridhar Reddy is one of the most renowned and professionally successful Dental, Oral and Maxillofacial Surgeons of India. He runs the largest and most sophisticated dental facility in the country, "Dr. Sridhar International Dental Hospital" in Vijayawada.
              </p>

              <p>
                Spread over 10,000 sq.ft., equipped with state-of-the-art technology and supported by a highly proficient team of specialists, the hospital offers a complete spectrum of advanced dental treatments.
              </p>

              <p>
                A pioneer in introducing laser and blue-cam technology into Indian dentistry, Dr. Sridhar made high-end dental care accessible to the common people. Rising from a rural agrarian family, he built his success through dedication, expertise, and relentless hard work.
              </p>
            </div>

            {/* Optional CTA */}
            <div className="mt-10">
              <button className="px-6 py-3 bg-blue-600 text-white rounded-full shadow-md hover:bg-blue-700 transition duration-300">
                Book Appointment
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</RevealFromBottom>


        {/* Personal Background & Journey */}
        <RevealFromBottom delay={300}>
          <section className="mb-20">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">
              A Self-Made Journey of Dedication
            </h2>
            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-400">
              <p className="text-gray-700 leading-relaxed mb-6">
                Dr. Sridhar is a self-made man that hailed from a rural agrarian family. He strived hard against all odds to become a proficient dental surgeon, who brought beautiful smiles into lakhs of faces with rare dental surgeries and treatments.
              </p>
              {/* Image slot: Modern dental treatment / laser equipment */}
              <div className="my-8 overflow-hidden rounded-lg">
                <img
                  src={Aboutdrimg}
                  alt="State-of-the-art dental treatment room"
                  className="h-72 w-full object-cover rounded-lg shadow-sm transition-transform duration-700 hover:scale-105"
                />
              </div>
              <p className="text-sm text-gray-500 mt-2 text-center">State-of-the-art dental treatment environment</p>
            </div>
          </section>
        </RevealFromBottom>

        {/* Humanitarian Impact & Awards Highlights */}
        <RevealFromBottom delay={400}>
          <section className="mb-20">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">
              Service to Humanity & Recognitions
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <HighlightCard
                title="Child Welfare"
                content="In recognition of his yeomen services to over 8.5 lakhs children, Dr. Sridhar was honored by Hon'ble President of India Shri Ramnath Kovind with NATIONAL CHILD WELFARE AWARD in 2019."
              />
              <HighlightCard
                title="Professional Excellence"
                content="He was awarded 'OUTSTANDING DENTIST OF THE YEAR' for four consecutive years by FAMDENT Awards of Excellence."
              />
              <HighlightCard
                title="Free Services via Foundation"
                content="Influenced by the ideal of selfless service, through Dr. Sridhar Oral Health Foundation, he has been offering FREE DENTURES to the aged poor people and free treatment to orphans and destitute children."
              />
              <HighlightCard
                title="State Recognition"
                content="He was honoured with AP State Government 'KALARATNA HAMSA AWARD' in recognition of his professional and social services."
              />
              <HighlightCard
                title="Guinness World Record"
                content="He achieved GUINNESS WORLD RECORD by conducting the World's Largest Dental Health Check with 21,233 students and 800 Dentists in a single day."
              />
              {/* Image slot: Dental health check camp */}
              <div className="col-span-1 md:col-span-2 lg:col-span-3 mt-6 overflow-hidden rounded-lg shadow-md">
                <img
                  src={Aboutdrimg2}
                  alt="World's Largest Dental Health Check"
                  className="h-92 w-full object-cover rounded-lg shadow-sm transition-transform duration-700 hover:scale-105"
                />
                <p className="text-sm text-gray-500 mt-2 text-center">World's Largest Dental Health Check – Guinness Record</p>
              </div>
            </div>
          </section>
        </RevealFromBottom>

        {/* Red Cross & Blood Donation */}
        <RevealFromBottom delay={500}>
          <section className="mb-20">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">
              Red Cross Service & Blood Donation Efforts
            </h2>
            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-400">
              <p className="text-gray-700 leading-relaxed mb-6">
                Dr. Sridhar has been serving as the Chairman of Indian Red Cross Society, Krishna District in Andhra Pradesh. His committed services provided solace to thousands of lives in distress.
              </p>
              <ul className="list-disc pl-6 space-y-3 text-gray-700 mb-6">
                <li>He organized Tiranga Mega Blood Donation Camp in which 8,300 blood units are collected in just 8 hours.</li>
                <li>He reached relief to 14,000 families during Krishna River Floods in 2010 and received NTR TRUST AWARD for the yeomen services.</li>
                <li>He has been prolonging the lives of hundreds of Thalassemia children by providing blood free of cost.</li>
              </ul>
              {/* Image slot: Blood donation camp */}
              <div className="mt-8 overflow-hidden rounded-lg shadow-md">
                <img
                  src={Aboutdrimg3}
                  alt="Tiranga Mega Blood Donation Camp"
                  className="h-[30rem] w-full object-cover rounded-lg shadow-sm transition-transform duration-700 hover:scale-105"
                />
                <p className="text-sm text-gray-500 mt-2 text-center">Tiranga Mega Blood Donation Camp – 8,300 units in 8 hours</p>
              </div>
            </div>
          </section>
        </RevealFromBottom>

        {/* SKCV Children's Trust */}
        <RevealFromBottom delay={600}>
          <section className="mb-20">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">
              SKCV Children's Trust – Saving Street Children
            </h2>
            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-400">
              <p className="text-gray-700 leading-relaxed mb-6">
                Dr. Sridhar, as the Chairman of SKCV Children's Trust, has been saving the lives of hundreds of street children and runaway children, who are otherwise vulnerable to exploitation and sexual abuse.
              </p>
              <ul className="list-disc pl-6 space-y-3 text-gray-700 mb-6">
                <li>Through Childline, he is rescuing children from Railway Station and restoring them secure childhood.</li>
                <li>He is running three homes for the street children, which provide free food, shelter, quality education and professional training to give them a dignified life.</li>
                <li>So far, thousands of children are given new life through the trust.</li>
                <li>Dr. Sridhar services to street children were specially mentioned while National Child Welfare Award being presented.</li>
              </ul>
              {/* Image slot: Children rehabilitation */}
              <div className="mt-8 overflow-hidden rounded-lg shadow-md">
                <img
                  src={Aboutdrimg4}
                  alt="Empowering street children"
                  className="h-[28rem] w-full object-cover rounded-lg shadow-sm transition-transform duration-700 hover:scale-105"
                />
                <p className="text-sm text-gray-500 mt-2 text-center">Empowering street children through education and care</p>
              </div>
            </div>
          </section>
        </RevealFromBottom>

        {/* Awards & Positions */}
        <RevealFromBottom delay={500}>
          <section className="mb-20">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">
              Positions Held & Awards Received
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-400">
                <h3 className="text-2xl font-semibold text-blue-800 mb-6">Positions Held</h3>
                <ul className="space-y-3 text-gray-700">
                  <li>Chairman, Indian Red Cross Society, A.P. State Branch</li>
                  <li>Chairman, Dr. Sridhar Oral Health Foundation</li>
                  <li>Chairman, SKCV Children's Trust for Street Children</li>
                </ul>
                {/* Image slot: Award ceremony */}
                <div className="mt-6 overflow-hidden rounded-lg shadow-md">
                  <img
                    src={Aboutdrimg6}
                    alt="Receiving Ugadi Puraskar Award"
                    className="aboutawardsimg h-[28rem]  w-full object-cover rounded-lg shadow-sm transition-transform duration-700 hover:scale-105"
                  />
                  <p className="text-sm text-gray-500 mt-2 text-center">Receiving Ugadi Puraskar Award from the Hon’ble Chief Minister of Andhra Pradesh Sri. N. Chandra Babu Naidu</p>
                </div>
              </div>

              <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-400">
                <h3 className="text-2xl font-semibold text-blue-800 mb-6">Awards from Hon'ble President of India at Rashtrapati Bhavan</h3>
                <ul className="space-y-3 text-gray-700">
                  <li>2019 – National Child Welfare Award by Shri Ramnath Kovind</li>
                  <li>2016 – Red Cross Gold Medal by Shri Pranab Mukherjee</li>
                  <li>2014 – Red Cross Shield by Shri Pranab Mukherjee</li>
                </ul>
                {/* Image slot: Award ceremony */}
                <div className="mt-6 overflow-hidden rounded-lg shadow-md">
                  <img
                    src={Aboutdrimg5}
                    alt="Receiving National Award"
                    className="h-[28rem] w-full object-cover rounded-lg shadow-sm transition-transform duration-700 hover:scale-105"
                  />
                  <p className="text-sm text-gray-500 mt-2 text-center">Receiving National Award at Rashtrapati Bhavan</p>
                </div>
              </div>
            </div>

            <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <AwardCard year="2020" title="Guinness World Record" desc="Achieved GUINNESS WORLD RECORD FOR 'MOST PEOPLE TO SIGN UP TO DONATE BLOOD IN 8 HOURS' ON 15th FEBRUARY 2020." />
              <AwardCard year="2018" title="World's largest Dental Health Check" desc="Conducted with 21,233 students and 800 Dental Surgeons at Andhra Loyola College auditorium, Vijayawada on 05-12-2018" />
              <AwardCard year="2014" title="Certificate of Merit" desc="by Hon'ble Union Health Minister Shri J. P. Nadda" />
              <AwardCard year="2018" title="Kalaratna Hamsa Award" desc="in the field of Medicine – Government of Andhra Pradesh" />
              <AwardCard year="2008–2019" title="Gold Medals & Seva Awards" desc="Received 15 Gold Medals and 2 Seva awards from Hon'ble Governors of Andhra Pradesh" />
              <AwardCard year="1999–2019" title="Meritorious Service Certificates" desc="Received 14 Meritorious Service Certificates from Govt. of Andhra Pradesh" />
              <AwardCard year="2010" title="NTR TRUST AWARD" desc="Received from Hon'ble Governor of AP and Sri N. Chandra Babu Naidu" />
              <AwardCard year="2013–2016" title="OUTSTANDING DENTIST OF THE YEAR" desc="from FAMDENT Excellence in Dentistry Awards for Four Consecutive Years" />
              <AwardCard year="2018" title="OUTSTANDING DENTIST AWARD" desc="at World Dental Conference, Dubai" />
              <AwardCard year="2018" title="Fellowship" desc="Bestowed Fellowship of International College of Dentists" />
              <AwardCard year="2018" title="Fellowship" desc="Bestowed Fellowship of Pierre Fauchard Academy" />
            </div>
          </section>
        </RevealFromBottom>

        {/* Personal Details */}
        <RevealFromBottom delay={500}>
          <section className="mb-20 bg-white p-10 rounded-3xl shadow-xl max-w-5xl mx-auto">
            <header className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900">
                Personal Details
              </h2>
              <div className="mt-4 h-1 w-20 bg-blue-600 mx-auto rounded-full" />
            </header>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-4xl mx-auto">
              
              {/* Left Column */}
              <dl className="space-y-6 text-gray-800">
                <div>
                  <dt className="text-sm font-semibold text-gray-500 uppercase tracking-wide">
                    Full Name
                  </dt>
                  <dd className="text-lg font-medium">
                    Dr. Arumalla Sridhar Reddy
                  </dd>
                </div>

                <div>
                  <dt className="text-sm font-semibold text-gray-500 uppercase tracking-wide">
                    Parents
                  </dt>
                  <dd className="text-lg">
                    Late Sri A. Vemana Reddy<br />
                    Smt. A. Lakshmi Rajyam
                  </dd>
                </div>

                <div>
                  <dt className="text-sm font-semibold text-gray-500 uppercase tracking-wide">
                    Date of Birth
                  </dt>
                  <dd className="text-lg">
                    21 December 1967
                  </dd>
                </div>

                <div>
                  <dt className="text-sm font-semibold text-gray-500 uppercase tracking-wide">
                    Native Place
                  </dt>
                  <dd className="text-lg">
                    Vijayawada
                  </dd>
                </div>
              </dl>

              {/* Right Column */}
              <dl className="space-y-6 text-gray-800">
                <div>
                  <dt className="text-sm font-semibold text-gray-500 uppercase tracking-wide">
                    Qualification
                  </dt>
                  <dd className="text-lg">
                    B.D.S., M.D.S.
                  </dd>
                </div>

                <div>
                  <dt className="text-sm font-semibold text-gray-500 uppercase tracking-wide">
                    Profession
                  </dt>
                  <dd className="text-lg">
                    Dental, Oral & Maxillofacial Surgeon
                  </dd>
                </div>

                <div>
                  <dt className="text-sm font-semibold text-gray-500 uppercase tracking-wide">
                    Permanent Address
                  </dt>
                  <dd className="text-lg leading-relaxed">
                    Chairman<br />
                    Dr. Sridhar International Dental Hospital<br />
                    Eluru Road<br />
                    Vijayawada – 521 002
                  </dd>
                </div>

                <div>
                  <dt className="text-sm font-semibold text-gray-500 uppercase tracking-wide">
                    Contact
                  </dt>
                  <dd className="text-lg">
                    <span className="block">📞 98481 28342</span>
                    <span className="block">
                      ✉️ <a href="mailto:drasridhar@yahoo.com" className="text-blue-600 hover:underline">
                        drasridhar@yahoo.com
                      </a>
                    </span>
                  </dd>
                </div>
              </dl>

            </div>
          </section>
        </RevealFromBottom>

        {/* Closing Quote */}
        <RevealFromBottom delay={500}>
          <div className="text-center italic text-gray-700 max-w-4xl mx-auto">
            <p className="text-xl leading-relaxed mb-6">
              He is a great human being, who is making a difference with his work and commitment to values.
            </p>
            <p className="font-medium">– DR. ILLA RAVI<br />Academic Administrator</p>
          </div>
        </RevealFromBottom>

      </div>
    </div>
  );
};

const HighlightCard = ({ title, content }) => (
  <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
    <h3 className="text-xl font-semibold text-blue-800 mb-3">{title}</h3>
    <p className="text-gray-700">{content}</p>
  </div>
);

const AwardCard = ({ year, title, desc }) => (
  <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 border-t-4 border-yellow-500">
    <div className="text-yellow-600 font-bold text-2xl mb-2">{year}</div>
    <h4 className="text-lg font-semibold mb-2">{title}</h4>
    <p className="text-gray-600 text-sm">{desc}</p>
  </div>
);

export default AboutDrSridhar;